const contentType = "Content-Type";
const applicationJson = "application/json";
const problemJson = "application/problem+json";

const get = async (
  url: string,
  data?: Record<string, string>,
  headers?: Record<string, string>
) => {
  try {
    if (data) {
      url += `?${new URLSearchParams(data)}`;
    }
    const response = await fetch(url, headers && { headers });
    return await formatResponse(response);
  } catch {
    return {
      ok: false,
      body: null,
    };
  }
};

const post = async (
  url: string,
  data?: Record<string, any>,
  headers?: Record<string, string>
) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        [contentType]: applicationJson,
        ...headers,
      },
      body: JSON.stringify(data),
    });
    return await formatResponse(response);
  } catch {
    return {
      ok: false,
      body: null,
    };
  }
};

const formatResponse = async (response: Response) => {
  const responseContent = response.headers.get(contentType);
  const isJson =
    responseContent &&
    (responseContent.startsWith(applicationJson) ||
      responseContent.startsWith(problemJson));
  return {
    ok: response.ok,
    body: isJson ? await response.json() : null,
  };
};

export { get, post };
